import { FC } from "react";
import Section from "components/gonzo/parts/Section";
import AnchorTarget from "components/official/AnchorTarget";
import Headline from "components/gonzo/parts/Headline";
import Description from "components/gonzo/parts/Description";
import Content from "components/gonzo/parts/Content";
import BreakPc from "components/gonzo/parts/BreakPc";

const Exhibition: FC = () => {
  return (
    <Section>
      <AnchorTarget id="exhibition" />
      <Headline
        multiRow
        src={["/image/lp/gonzo/exhibition/exhibition_title_1.png", "/image/lp/gonzo/exhibition/exhibition_title_2.png"]}
        alt="オンライン展示会"
      />
      <Content>
        <Description>
          クラウドファンディングで1000万円以上の応援を頂いた際に
          <BreakPc />
          「無料のオンライン展示会」を開催いたします。
          <br />
          その際は、応援の有無に関わらず、参加ご希望者皆様をご招待させていただきます。
          <br />
          ※応援いただいた方には優先入場の特典をお付けする予定です。
          <br />
          <br />
          詳細は後日発表致します。
        </Description>
      </Content>
    </Section>
  );
};
export default Exhibition;
